import { toast } from 'react-toastify';
import { transformAsCurrency } from '~/utils/functions';

interface res {
  valid: boolean;
  campos: string;
}

interface prod {
  cod_loja?: number | string;
  cod_produto?: number | string;
  des_produto?: string;
  flg_ipv: boolean;
  cod_associado: number | string | null;
}

interface dataProps {
  busca_produto?: { value: number | string; label: string } | any;
  des_produto?: string;
  flg_ipv: boolean;
  qtd_receita: number | string;
  per_despesa_producao: number | string;
}

export function validaParaAdd(data: dataProps, prodAtual: prod): res {
  let resp: res = { valid: true, campos: '' };
  if (
    data.busca_produto === undefined ||
    data.busca_produto.value === '' ||
    data.busca_produto === ''
  ) {
    toast.warn('Produto deve ser informado');
    resp = { valid: false, campos: 'busca_produto' };
    return resp;
  }

  if (prodAtual.cod_associado !== null) {
    toast.warn(`Produto não pode ser associado.`);
    resp = { valid: false, campos: 'busca_produto' };
    return resp;
  }

  if (
    transformAsCurrency(data.qtd_receita) < 0.001 ||
    data.qtd_receita === '0,000'
  ) {
    toast.warn('Quantidade não pode ser zerada.');
    resp = { valid: false, campos: 'qtd_receita' };
    return resp;
  }

  return resp;
}
